import { ListItemBox } from "lib/@components/ListItemBox"
import { Bound } from "lib/@components/binding/Bound"
import { CustomScheduleActions } from "./selection-actions-slot-definitions"

export function SelectionActions({ publishedItems = [], draftItems = [], retiredItems = [], regimeUsage = [] }) {
    return (
        <Bound
            publishedItems={publishedItems}
            draftItems={draftItems}
            retiredItems={retiredItems}
            regimeUsage={regimeUsage}
        >
            <ListItemBox spacing={1} sx={{ width: "auto" }}>
                <CustomScheduleActions.Slot />
            </ListItemBox>
        </Bound>
    )
}
